import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RMWContext } from 'app/shared/providers/RMWContext';

// containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

import HeadWrapper from 'app/shared/components/HeadWrapper';
import TableMFH from 'app/shared/components/TableMFH';

import LoadingConstants from 'app/shared/constants/LoadingConstants';
import ModalConstants from 'app/shared/constants/ModalConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

import UserManagementActions from 'app/shared/actions/UserManagementActions';
import ModalActions from 'app/shared/actions/ModalActions';

import CompanyProperty from 'app/shared/model/CompanyProperty';

import { Row, Col } from '@zillow/zrs-comet';
import { Text, TextButton } from '@zillow/constellation';

import { StyledTopBanner } from './StyledComponents';

const UnrecognizedUsersPage = () => {
    const { paths } = useContext(RMWContext);
    const dispatch = useDispatch();
    const unrecognizedUsers = useSelector(state => state.userManagement.unrecognizedUsers.unrecognizedUsers);
    const loadingState = useSelector(state => state.userManagement.unrecognizedUsers.loadingState);

    React.useEffect(() => {
        dispatch(UserManagementActions.getUnrecognizedUsers());
        return () => dispatch(UserManagementActions.unrecognizedUsersInit());
    }, []);

    const previewProperties = (listings) => {
        const onLoadProperties = () => {
            const properties = listings.map(property => CompanyProperty(property));
            return dispatch({
                type: DispatchConstants.USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_SUCCESS,
                payload: { properties },
            });
        };
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.USER_MANAGEMENT_PROPERTY_LIST_MODAL,
            onLoadProperties,
            header: 'Properties',
        }));
    };

    const handleAddUser = (email) => {
        dispatch(UserManagementActions.currentUserSetEmail(email));
        window.router.transitionTo(`${paths.userManagementPage}/${paths.userManagementAddUser}`);
    };

    const columnConfig = [
        {
            width: 5,
            header: 'Email',
            dataKey: 'email',

        },
        {
            width: 5,
            header: 'Properties',
            renderer: data => (
                <TextButton onClick={() => previewProperties(data.listings)}>
                    {data.listings.length}
                </TextButton>
            ),
        },
        {
            width: 2,
            header: 'Invite',
            renderer: data => (
                <TextButton onClick={() => handleAddUser(data.email)}>
                        Invite
                </TextButton>
            ),
        },
    ];

    const renderEmptyBanner = () => {
        if (unrecognizedUsers.length === 0 && loadingState === LoadingConstants.SUCCESS) {
            return (
                <Row>
                    <Col>
                        <Text className="empty-message">No Unrecognized users found</Text>
                    </Col>
                </Row>
            );
        }
        return null;
    };

    const renderTopBanner = () => (
        <StyledTopBanner>
                The following emails have permissions to one ore more listings in your company.
            {' '}
                You can invite them to join your company as users.
        </StyledTopBanner>
    );

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div className="ActivityHistoryPage">
                <HeadWrapper title="Unrecognized Users" />
                <TableMFH
                    columnConfig={columnConfig}
                    data={unrecognizedUsers}
                    idKey="activityHistory"
                    isLoading={loadingState === LoadingConstants.LOADING || loadingState === LoadingConstants.INITIAL}
                    TopBannerComponent={renderTopBanner}
                />
                {renderEmptyBanner()}
            </div>
        </AuthCheckWrapper>
    );
};

export default UnrecognizedUsersPage;
